import { graphql, useStaticQuery } from "gatsby"
import { useLocale } from ".."

export const useSiteQueryTwo = () => {
  const locale = useLocale()

  const {
    allContentfulDigitupGlobalForm: { edges },
  } = useStaticQuery(
    graphql`
      query globalForm {
        allContentfulDigitupGlobalForm {
          edges {
            node {
              node_locale
                tagline
                para
                contactUsTitle
                personName
                personNamePlaceholder
                phone
                phonePlaceholder
                email
                emailPlaceholder
                companyName
                companyNamePlaceholder
                websiteUrl
                websiteUrlPlaceholder
                countryOfOperation
                countryOfOperationPlaceholder
                interestIn
                interestInPlaceholder
                contactUsError
                contactUsError2
                contactUsError3
                contactUsError4
                applyJobTitle
                portfolioUrl
                portfolioUrlPlaceholder
                currentCtc
                currentCtcPlaceholder
                expectedCtc
                expectedCtcPlaceholder
                totalWorkExperience
                totalWorkExperiencePlaceholder
                resume
                resumeText
                applyJobError
                applyJobError2
                applyJobError3
                contactUsButton
                applyJobButton
                uploadResume
                comingSoonButton
                comingSoonText
                jobOverviewSearchText
                jobOverviewSearchPlaceholder
                jobOverviewSelectPlaceholder
                filterByDepartment
                filterJobCategory
                clear
                filterBy
                searchButton
                contactMapButtonText
            }
          }
        }
      }
    `
  )

  const localeData = locale
    ? edges.filter(({ node }) => node.node_locale === locale)
    : edges.filter(({ node }) => node.node_locale === "en-US")
  const site = localeData.reduce((acc, val) => ({ ...acc, ...val.node }), {})


  return site
}
